// extracted by mini-css-extract-plugin
export var component = "ArticleBroadcastChannel-module--component--5lKs9";
export var facebook = "ArticleBroadcastChannel-module--facebook--fH8oD";
export var player = "ArticleBroadcastChannel-module--player--Lst1k";
export var wrapper = "ArticleBroadcastChannel-module--wrapper--Lusqr";